module.exports = __webpack_public_path__ + "analytics.svg?e22e29e688076857e1ea92db00c43b06";